import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Calendar } from "lucide-react";
import api from "../lib/api";
import Seo from "../components/Seo";
import { safeHtml } from "../lib/safeHtml";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    api.get(`/public/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setError(true));
  }, [slug]);

  if (error) return (
    <div className="max-w-2xl mx-auto text-center py-24 px-6">
      <h1 className="font-display text-4xl text-[#5D2C8F]">Post not found</h1>
      <Link to="/blog" className="sac-btn-secondary mt-6 inline-flex">Back to journal</Link>
    </div>
  );
  if (!post) return <div className="p-16 text-center text-[#8A6DA3]">Loading…</div>;

  return (
    <article className="max-w-3xl mx-auto px-6 lg:px-10 pt-12 pb-24" data-testid="blog-post-page">
      <Seo path={`/blog/${slug}`} title={post.title} description={post.excerpt || "Seasons Art Class East Croydon — a note from our South London art studio."} type="article"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "BlogPosting",
          "headline": post.title,
          "description": post.excerpt,
          "datePublished": post.published_at,
          "dateModified": post.published_at || post.created_at,
          "author": { "@type": "Organization", "name": "Seasons Art Class East Croydon" },
          "publisher": { "@type": "Organization", "name": "Seasons Art Class East Croydon", "logo": { "@type": "ImageObject", "url": "https://www.artclassesineastcroydon.co.uk/logo.png" } },
          "mainEntityOfPage": `https://www.artclassesineastcroydon.co.uk/blog/${slug}`
        }}
      />
      <Link to="/blog" className="text-sm text-[#8A6DA3] inline-flex items-center gap-1 mb-6 hover:text-[#5D2C8F]"><ArrowLeft size={14} /> back to journal</Link>
      <div className="flex items-center gap-2 text-xs text-[#8A6DA3]"><Calendar size={12} /> {new Date(post.published_at || post.created_at).toLocaleDateString("en-GB")}</div>
      <h1 className="font-display text-4xl md:text-5xl text-[#5D2C8F] mt-2 leading-tight">{post.title}</h1>
      {post.cover_image && <img src={post.cover_image} alt="" className="rounded-2xl w-full object-cover mt-8 mb-8" />}
      <div className="prose prose-lg max-w-none text-[#3A2A47] leading-relaxed [&>h2]:font-display [&>h2]:text-[#5D2C8F] [&>h2]:text-3xl [&>h2]:mt-8 [&>p]:mt-4 [&>ul]:mt-3 [&>ul]:ml-6 [&>ul]:list-disc [&_li]:mt-1" dangerouslySetInnerHTML={safeHtml(post.body_html)} />
      {post.tags?.length > 0 && (
        <div className="mt-10 flex flex-wrap gap-2">
          {post.tags.map((t) => <span key={t} className="px-3 py-1 rounded-full bg-[#F4EDDD] text-xs text-[#5D2C8F]">#{t}</span>)}
        </div>
      )}
    </article>
  );
}
